var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll",on:{"mouseover":function($event){return _vm.$emit('mouseover')},"mouseout":function($event){return _vm.$emit('mouseout')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }